/* Nights Well Rested - minimal behaviour.
   Three jobs only: reveal on scroll, FAQ disclosure, sticky buy bar.
   No framework, no scroll listeners, no dependencies. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---------------------------------------------------- */
  var revealables = document.querySelectorAll('[data-reveal]');
  if (reduced || !('IntersectionObserver' in window)) {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var revealer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        revealer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    revealables.forEach(function (el) { revealer.observe(el); });
  }

  /* ---- FAQ disclosure --------------------------------------------------- */
  document.querySelectorAll('.faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!open));
      if (!panel) return;
      if (open) panel.removeAttribute('data-open');
      else panel.setAttribute('data-open', '');
    });
  });

  /* ---- sticky buy bar ---------------------------------------------------
     Appears once the hero's buy button has scrolled away, hides again when
     the page's own buy section is on screen so the two never compete. */
  var bar = document.querySelector('[data-buybar]');
  if (bar && 'IntersectionObserver' in window) {
    var heroCta = document.querySelector('[data-hero-cta]');
    var buySection = document.querySelector('[data-buy-section]');
    var heroGone = false;
    var buyVisible = false;

    var sync = function () {
      if (heroGone && !buyVisible) bar.setAttribute('data-show', '');
      else bar.removeAttribute('data-show');
    };

    if (heroCta) {
      new IntersectionObserver(function (e) {
        heroGone = !e[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(heroCta);
    }

    if (buySection) {
      new IntersectionObserver(function (e) {
        buyVisible = e[0].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(buySection);
    }
  }
})();
